<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="logList"
      :loading="loadingMessage"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center" style="font-weight: bold">
          {{ props.item.id }}
        </td>
        <td class="text-xs-center">{{ props.item.user_name }}</td>
        <td class="text-xs-center">{{ props.item.rider_name }}</td>
        <td class="text-xs-center" style="white-space: nowrap;">
          {{ props.item.action }}
        </td>
        <td class="text-xs-center" style="white-space: nowrap;">
          {{ moment(props.item.create_at).format("YYYY-MM-DD HH:mm") }}
        </td>
        <td class="text-xs-center">{{ props.item.log_detail }}</td>
      </template>

      <template slot="no-data">
        <div v-if="loadingMessage === true">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>
    <v-divider></v-divider>
    <div style="display: flex; align-items: center; justify-content: center">
      <div style="width: 50vw" class="my-3">
        <v-pagination
          class="mt-3"
          v-model="currentPage"
          :length="totalItems"
          @input="getData()"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import _ from "lodash";
import moment from "moment";

export default {
  data: () => ({
    currentPage: 1,
    totalItems: 0,
    pageItems: 20,
    loadingMessage: false,
    headers: [
      {
        text: "Log ID",
        align: "center",
        sortable: false,
        value: "id",
      },

      {
        text: "User name",
        align: "center",
        value: "user_first_name",
        sortable: false,
      },
      {
        text: "Rider name",
        align: "center",
        value: "user_last_name",
        sortable: false,
      },
      {
        text: "Action",
        align: "center",
        value: "user_sum_point",
        sortable: false,
      },

      {
        text: "Create at",
        align: "center",
        value: "user_email",
        sortable: false,
      },
      {
        text: "Log detail",
        align: "center",
        value: "user_country_tel",
        sortable: false,
      },
    ],
    logList: [],
  }),
  components: {},
  computed: {},
  created() {
    this.getData();
  },

  methods: {
    ...mapActions({
      fetchRequestCashLog: "fetchCashRider/fetchRequestCashLog",
    }),
    moment,
    async getData() {
      this.loadingMessage = true;
      let config = {
        page_size: this.pageItems,
        current_page: this.currentPage,
      };
      let response = await this.fetchRequestCashLog(config);
      this.loadingMessage = false;
      if (response == false) return;
      this.logList = response.collect_data;
      this.totalItems = Math.ceil(response.count / this.pageItems);
    },
  },
};
</script>
